import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  Button, Icons,
} from '../../../components/base/BootstrapComponents';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import TextInput from '../../../components/fields/TextInput/TextInput';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import ParkingMeterDTO from '../../../dto/ParkingMeterDTO';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import Tooltip from '../../../components/base/Tooltip/Tooltip';
import HelperTooltip from './HelperTooltip';
import { optionClassFormatter } from '../../../utils/formatters';
import ParkingMeterFilter from './ParkingMeterFilter';
import { metricKeys, PARKING_METER_STATUS } from '../constants';
import { getParkingMetersData } from '../reducer';
import { loadHostList, loadHostStatusesList } from '../actions';
import {
  getJSONFromString,
  getPaginationOpts, responseLogWithNotification, useSortData, saveFilter,
} from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import ParkingMeterHistoryPopup from './ParkingMeterHistoryPopup';
import ParkingMeterGrid from './ParkingMeterGrid';
import ParkingMeterMap from './ParkingMeterMap';
import ParkingMeterMatrix from './ParkingMeterMatrix';
import { convertMetricFilters, sortByStatus } from '../parking-meter-utils';
import MatrixReportPopup from './MatrixReportPopup';

const tabOptions = [
  { value: 0, label: 'Таблица' },
  { value: 1, label: 'Карта' },
  { value: 2, label: 'Матрица' },
];

const updatePeriods = [
  { value: 0, name: 'Не обновлять' },
  { value: 10, name: '10 секунд' },
  { value: 30, name: '30 секунд' },
  { value: 60, name: '1 минута' },
  { value: 300, name: '5 минут' },
];

export default function ParkingMetersPage() {
  const {
    loadingHostComponents,
    loadingHostList,
    hostList,
    hostListMeta,
    showHistoryPopup,
    currentParkingMeter,
    loadingHostCommandDispatch,
    loadingHostStatusesList,
    hostStatusesList,
    hostStatusesListMeta,
    loadingHostDetail,
    hostDetail,
    loadingHistoryExportWord,
    zones,
    loadingZones,
    loadingHostProblems,
  } = useSelector(getParkingMetersData);
  const dispatch = useDispatch();
  const handleLoadingHostList = opts => {
    const filterData = getValues();
    let sortData = [...sort];
    if (opts && !opts.page) {
      opts.page = 1;
    }
    if (opts && opts.sortData) {
      sortData = [...opts.sortData];
    }
    Object.keys(filterData).forEach(key => {
      if (!filterData[key]) {
        delete filterData[key];
      }
    });
    saveFilter(filterData, 'parking-meter-filter');
    if (filterData) {
      convertMetricFilters(filterData);
    }
    const paginationOpts = getPaginationOpts(hostListMeta, opts);
    const requestData = {
      metricKeys,
      ...paginationOpts,
      filter: filterData,
      sort: sortData.join(','),
    };
    const selectedTab = getTab();
    const action = !selectedTab || !selectedTab.value
      ? loadHostList
      : loadHostStatusesList;
    if (currentTimeOut) {
      clearTimeout(currentTimeOut);
    }
    if (window.location.pathname === '/parking-meters') {
      dispatch(action(requestData)).catch(responseLogWithNotification).finally(() => {
        if (updatePeriod) {
          const t = setTimeout(() => handleLoadingHostList(opts), updatePeriod * 1000);
          clearTimeout(window.parkingMetreTimeOut);
          window.parkingMetreTimeOut = t;
        }
      });
    }
  };
  const intl = useIntl();
  const { formatMessage } = intl;
  const getTab = () => getJSONFromString(window.localStorage.getItem('parking-meter-tab')) || tabOptions[0];
  const saveTab = value => {
    window.localStorage.setItem('parking-meter-tab', JSON.stringify(value));
    setTab(value);
  };
  const [zoom, setZoom] = useState(10);
  const [selectedTab, setTab] = useState(getTab());
  const [selectedHost, setHost] = useState(null);
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [fullScreen, setFullScreenMap] = useState(false);
  const [isCenter, setIsCenter] = useState(false);
  const [currentTimeOut, setCurrentTimeOut] = useState(null);
  const [showMatrixReport, setShowMatrixReport] = useState(false);
  const defaultValues = {
    query: '',
    host: '',
    status: 0,
    address: '',
    zbx_zone: '',
    update_period: 0,
    available_status: 0,
    DOOR_LOWER_UNKNOWN: false,
    DOOR_LOWER_OPENED: false,
    DOOR_LOWER_CLOSED: false,
    DOOR_UPPER_UNKNOWN: false,
    DOOR_UPPER_OPENED: false,
    DOOR_UPPER_CLOSED: false,
    DOOR_LOCK_LOWER_ERROR: false,
    DOOR_LOCK_LOWER_UNKNOWN: false,
    DOOR_LOCK_LOWER_LOCKED: false,
    DOOR_LOCK_LOWER_UNLOCKED_CLOSED: false,
    DOOR_LOCK_LOWER_UNLOCKED_OPENED: false,
    DOOR_LOCK_UPPER_ERROR: false,
    DOOR_LOCK_UPPER_UNKNOWN: false,
    DOOR_LOCK_UPPER_LOCKED: false,
    DOOR_LOCK_UPPER_UNLOCKED_CLOSED: false,
    DOOR_LOCK_UPPER_UNLOCKED_OPENED: false,
    PSS_ERROR: false,
    PSS_UNKNOWN: false,
    PSS_UNREGISTERED: false,
    PSS_OK: false,
    PS_ERROR: false,
    PS_PAPER_EMPTY: false,
    PS_PAPER_LOW: false,
    PS_UNKNOWN: false,
    PS_OK: false,
    POWER_ERROR: false,
    POWER_LOW_POWER: false,
    POWER_UNKNOWN: false,
    POWER_OK: false,
    PAYMENT_ERROR: false,
    PAYMENT_UNKNOWN: false,
    PAYMENT_IDLE: false,
    PAYMENT_WAIT_CARD: false,
    PAYMENT_WAIT_BANK: false,
    PAYMENT_COMPLETE: false,
  };
  const {
    register, watch, getValues, setValue, reset, resetField,
  } = useForm({
    defaultValues: { ...defaultValues, ...(JSON.parse(localStorage.getItem('parking-meter-filter')) || {}) },
  });
  const formData = getValues();
  watch();
  useEffect(() => {
    const subscription = watch(value => {
      if (!getValues('update_period')) {
        setUpdatePeriod(0);
      }
      handleLoadingHostList();
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  const [updatePeriod, setUpdatePeriod] = useState(0 || getValues('update_period'));
  useEffect(() => { handleLoadingHostList(); return () => { clearTimeout(window.parkingMetreTimeOut); }; }, [updatePeriod]);
  useEffect(() => handleLoadingHostList({ page: 1 }), [selectedTab]);
  const { changeSort, sort } = useSortData('', () => handleLoadingHostList(), 'parking-meter-sort');
  const statusOptions = Object.values(PARKING_METER_STATUS).map(v => ({ value: Number(v), nameId: `parking.meter.status.${v}` })).reverse();
  const DTO = new ParkingMeterDTO();
  const attributes = DTO.getAttributesByName();
  const triggerFullScreen = value => setFullScreenMap(value);

  const sortedHostStatusesList = hostStatusesList.sort(sortByStatus);

  const showOnMap = item => {
    saveTab(tabOptions[1]);
    setHost(item);
  };

  const filterCount = Object.keys(formData).filter(key => formData[key]).length;

  return (
    <div className={classNames('parking-meters-page content g-0 pb-4', { 'page-with-map-fullscreen': fullScreen })}>
      <Loader global loading={loadingHostProblems || loadingZones || loadingHostList || loadingHostComponents || loadingHostCommandDispatch || loadingHostStatusesList || loadingHostDetail || loadingHistoryExportWord} />
      <PageHeader header="Информация о парковочном оборудовании">
        <TabMenu
          selectedTab={selectedTab}
          options={tabOptions}
          onSelectOptions={item => { saveTab(item); setHost(null); }}
        />
      </PageHeader>
      <FilterRow className="filter-row">
        <div className="parking-meter-helper">
          <Tooltip
            tooltipContent={<HelperTooltip />}
            content={<Icons customIcon icon="help-outline" className="parking-meter-helper-icon" />}
          />
        </div>
        <CustomSelectInput
          label="Период обновления"
          placeholder="Период обновления"
          dtoObject={attributes.status}
          inputProps={{
            value: getValues('update_period'),
            ...register('update_period'),
            onChange: event => { setValue('update_period', event.target.value || 0); setUpdatePeriod(event.target.value || 0); },
          }}
          className="small parking-meter-state-select no-border"
          options={updatePeriods}
        />
        <FieldWithAttributeDTO
          inputBefore={<Icons customIcon className="search-icon" width={24} height={17} icon="search" />}
          type="text"
          component={TextInput}
          dtoObject={{
            name: 'query',
            type: String,
            validators: [],
            labelKey: 'search',
          }}
          inputProps={{
            ...register('query', { maxLength: 30 }),
            value: getValues('query'),
          }}
          className="small no-border search-field"
        />
        <FieldWithAttributeDTO
          type="text"
          component={TextInput}
          dtoObject={attributes.host}
          inputProps={{
            ...register('host'),
            value: getValues('host'),
          }}
          className="small no-border host-filter"
        />
        <FieldWithAttributeDTO
          type="text"
          component={CustomSelectInput}
          dtoObject={attributes.status}
          inputProps={{
            value: Number(getValues('status')),
            onChange: e => {
              setValue('status', e.target.value);
            },
          }}
          className="small parking-meter-state-select no-border status-filter"
          options={statusOptions}
          inputClassName={optionClassFormatter(getValues('status') || 0)}
          addPlaceholder
          renderOption={item => (
            <div className={optionClassFormatter(item)}>
              {!item.name && item.nameId ? formatMessage({ id: item.nameId }) : item.name || ''}
            </div>
          )}
        />
        <Button className="filter-button" onClick={() => { setOpenFilter(true); setHost(null); }}>
          <Icons width={15} height={15} customIcon icon="filter" className="button-icons" />
          Все фильтры
          {filterCount ? <div className="filter-count">{filterCount}</div> : null}
        </Button>
        {selectedTab && selectedTab.value === 2 ? <Button className="export-button" onClick={() => setShowMatrixReport(true)}>Сформировать отчёт</Button> : null}
        {isOpenFilter
          ? (
            <ParkingMeterFilter
              meta={!selectedTab || !selectedTab.value ? hostListMeta : hostStatusesListMeta}
              reset={reset}
              onHide={() => { setOpenFilter(false); }}
              register={register}
              getValues={getValues}
              setValue={setValue}
              resetField={resetField}
              zones={zones}
              defaultValues={defaultValues}
            />
          )
          : null}
      </FilterRow>
      {selectedTab && selectedTab.value === 0 ? <ParkingMeterGrid sort={sort} changeSort={changeSort} loading={loadingHostList} showOnMap={showOnMap} hostList={hostList} handleLoadingHostList={handleLoadingHostList} hostListMeta={hostListMeta} /> : null}
      {selectedTab && selectedTab.value === 1 && window.yandexMap ? <ParkingMeterMap selectedHost={selectedHost} hostDetail={hostDetail} setHost={setHost} hostStatusesList={hostStatusesList} handleLoadingHostList={handleLoadingHostList} hostListMeta={hostListMeta} zoom={zoom} setZoom={setZoom} triggerFullScreen={triggerFullScreen} isCenter={isCenter} setIsCenter={setIsCenter} /> : null}
      {selectedTab && selectedTab.value === 2 ? <ParkingMeterMatrix hostDetail={hostDetail} hostStatusesList={hostStatusesList} handleLoadingHostList={handleLoadingHostList} hostListMeta={hostListMeta} /> : null}
      {showHistoryPopup && currentParkingMeter ? <ParkingMeterHistoryPopup /> : null}
      {showMatrixReport && sortedHostStatusesList ? <MatrixReportPopup sortedHostStatusesList={sortedHostStatusesList} handleClose={() => setShowMatrixReport(false)} /> : null}
    </div>
  );
}
